// extracted by mini-css-extract-plugin
export default {"WidgetContainer":"WidgetContainer_WidgetContainer__-ipLo","Title":"WidgetContainer_Title__uegqG","Content":"WidgetContainer_Content__9KDPU"};